import { useStaticQuery, graphql } from "gatsby";

import logo from "~/images/channels4_profile.jpg";

const useSiteMetadata = () => {
    const data = useStaticQuery(graphql`
        query SiteMetadataQuery {
            site {
                siteMetadata {
                    siteUrl
                }
            }
            wp {
                optionsPage {
                    globalOptions {
                        ogImage {
                            sourceUrl
                        }
                    }
                }
            }
        }
    `);

    const companyLogo = data.wp.optionsPage.globalOptions.ogImage
        ? data.wp.optionsPage.globalOptions.ogImage.sourceUrl
        : logo;

    return {
        ...data.site.siteMetadata,
        companyLogo,
    };
};

export default useSiteMetadata;
